import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyFieldProps } from '@ngx-formly/material/form-field';

interface InputProps extends FormlyFieldProps {
  tooltip: string;
}

@Component({
    selector: 'lockton-apps-info-panel-type',
    templateUrl: './info-panel-type.component.html',
    styleUrls: ['./info-panel-type.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class InfoPanelTypeComponent extends FieldType<
  FieldTypeConfig<InputProps>
> {}
